<template>
    <transition
        enter-active-class="transition duration-100"
        enter-class="scale-0 opacity-0"
        leave-active-class="transition duration-100"
        leave-to-class="scale-0 opacity-0"
    >
        <slot />
    </transition>
</template>
